module.exports = __webpack_public_path__ + "img/img_sdlhqs_xyy_brand@3x.198176ca.png";